import React from 'react';
import { useMassUpdateServiceRequired } from 'ui-builder';
import { useEventsPublisher } from 'event-bus';
import { MassUpdateFormProps } from '../../../shared/widgets/MassUpdate';
import useRoadmapService from './roadmapService';
import { ConfirmPositiveActionPopup, usePopupFormManager } from 'features/nekst-widgets';
import { PLAN_TASKS_UPDATED } from 'nekst-api';

function MakeRoadmapForm(props: MassUpdateFormProps) {
  const roadmapService = useRoadmapService();
  const eventsPublisher = useEventsPublisher();

  return (
    <ConfirmPositiveActionPopup
      title="Mass Update: Portal Roadmap"
      submitFormFunc={async () => {
        await roadmapService.markAsIncludedToRoadmap(props.ids);
        eventsPublisher.publish(PLAN_TASKS_UPDATED, {});
      }}
      message={'Click "Confirm" to add the Selected Tasks to the Portal Roadmap.'}
    />
  );
}

export default function useMakeRoadmapForm() {
  const popupManager = usePopupFormManager();
  const massUpdateService = useMassUpdateServiceRequired();

  const openForm = () => {
    popupManager.openForm(
      <MakeRoadmapForm ids={massUpdateService.getCheckedIds()} />,
      true,
    );
  };

  return {
    openForm,
  };
}
